import { F, G } from "@mobily/ts-belt";
import * as React from "react";
import { useDebounce } from "../../hooks";
import trackSearchEvent from "../../util/searchTracking";
import s from "./BrowseShops.module.css";
import FilterPanel from "./components/FilterPanel";
import SearchBar from "./components/SearchBar";
import SelectedCategories from "./components/SelectedCategories";
import ShopGrid from "./components/ShopGrid";
import SortSelect from "./components/SortSelect";
import { defaultFilter, removeEmptyFilterKeys, useFilterParams } from "./utils";

const FilterIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="7" y1="12" x2="17" y2="12" />
    <line x1="10" y1="18" x2="14" y2="18" />
  </svg>
);

export default function BrowseShops() {
  const [showFilters, setShowFilters] = React.useState(false);
  const { filter, setFilter } = useFilterParams();

  useDebounce(
    () => {
      if (G.isObject(filter) && !F.equals(defaultFilter, filter)) {
        trackSearchEvent({
          action: "search-shops",
          payload: removeEmptyFilterKeys(filter),
        });
      }
    },
    320,
    [filter],
  );

  return (
    <div className={s.page}>
      <header>
        <h1 className={s.pageTitle}>Browse Shops</h1>
      </header>

      <div
        className={s.toolbar}
        role="search"
        aria-label="Shop search and sort"
      >
        <div className={s.searchWrap}>
          <SearchBar filter={filter} setFilter={setFilter} />
        </div>

        <div className={s.toolbarActions}>
          <SortSelect filter={filter} setFilter={setFilter} />

          <button
            type="button"
            className={s.filterToggleBtn}
            onClick={() => setShowFilters((prev) => !prev)}
            aria-expanded={showFilters}
            aria-controls="filter-panel"
          >
            <FilterIcon />
            {showFilters ? "Hide Filters" : "Show Filters"}
          </button>
        </div>
      </div>

      <SelectedCategories filter={filter} setFilter={setFilter} />

      <div className={s.layout}>
        <FilterPanel
          filter={filter}
          setFilter={setFilter}
          showFilters={showFilters}
        />

        <div>
          <ShopGrid filter={filter} setFilter={setFilter} />
        </div>
      </div>
    </div>
  );
}
